import api from './../../lib/api';
import http from './../../lib/http';
import Vue from 'vue';

export const PUSH_TEMPLATES_LIST_LOAD = 'PUSH_TEMPLATES_LIST_LOAD';
export const PUSH_TEMPLATES_LIST_LOAD_SELECT = 'PUSH_TEMPLATES_LIST_LOAD_SELECT';
export const PUSH_TEMPLATE_LOAD = 'PUSH_TEMPLATE_LOAD';
export const PUSH_TEMPLATE_CREATE = 'PUSH_TEMPLATE_CREATE';
export const PUSH_TEMPLATE_UPDATE = 'PUSH_TEMPLATE_UPDATE';
export const PUSH_TEMPLATE_DELETE = 'PUSH_TEMPLATE_DELETE';
export const PUSH_TEMPLATE_SET_EMPTY = 'PUSH_TEMPLATE_SET_EMPTY';
export const PUSH_TEMPLATES_LANGUAGES = 'PUSH_TEMPLATES_LANGUAGES';
export const PUSH_TEMPLATE_PREVIEW = 'PUSH_TEMPLATE_PREVIEW';

const PUSH_TEMPLATES_LIST_LOAD_SELECT_LOADING_CHANGE = 'PUSH_TEMPLATES_LIST_LOAD_SELECT_LOADING_CHANGE';
const PUSH_TEMPLATES_LIST_LOAD_SELECT_CHANGE = 'PUSH_TEMPLATES_LIST_LOAD_SELECT_CHANGE';
const PUSH_TEMPLATES_LIST_LOADING_CHANGE = 'PUSH_TEMPLATES_LIST_LOADING_CHANGE';
const PUSH_TEMPLATES_LIST_CHANGE = 'PUSH_TEMPLATES_LIST_CHANGE';

const PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES = 'PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES';
const PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_LOADING_CHANGE = 'PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_LOADING_CHANGE';
const PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_CHANGE = 'PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_CHANGE';

const PUSH_TEMPLATES_LANGUAGES_LOADING_CHANGE = 'PUSH_TEMPLATES_LANGUAGES_LOADING_CHANGE';
const PUSH_TEMPLATES_LANGUAGES_CHANGE = 'PUSH_TEMPLATES_LANGUAGES_CHANGE';

const PUSH_TEMPLATE_CHANGE = 'PUSH_TEMPLATE_CHANGE';
const PUSH_TEMPLATE_LOADING_CHANGE = 'PUSH_TEMPLATE_LOADING_CHANGE';
const PUSH_TEMPLATE_ERRORS_CHANGE = 'PUSH_TEMPLATE_ERRORS_CHANGE';
const PUSH_TEMPLATE_SAVING_CHANGE = 'PUSH_TEMPLATE_SAVING_CHANGE';
const PUSH_TEMPLATE_DELETING_CHANGE = 'PUSH_TEMPLATE_DELETING_CHANGE';

const push_template_empty = () => ({
  name: '',
  title: '',
  content: '',
  image: '',
  icon: '',
  link: '',
  status: 'active',
  language: 'ru',
  render_engine: 'jinja2',
});

const state = {
  push_templates_list: [],
  push_templates_list_total: 0,
  push_templates_list_per_page: 20,
  push_templates_list_page: 1,
  push_templates_list_loading: false,

  push_templates_list_select: [],
  push_templates_list_select_total: 0,
  push_templates_list_select_per_page: 20,
  push_templates_list_select_page: 1,
  push_templates_list_select_loading: false,

  push_template: push_template_empty(),
  push_template_loading: false,
  push_template_saving: false,
  push_template_errors: {},
  push_template_deleting: false,

  push_templates_list_select_companies: [],
  push_templates_list_select_companies_total: 0,
  push_templates_list_select_companies_per_page: 20,
  push_templates_list_select_companies_page: 1,
  push_templates_list_select_companies_loading: false,

  push_templates_languages: {},
  push_templates_languages_loading: false,
};

const actions = {
  /**
   * Загружает список шаблонов Push организации с пагинацией
   */
  [PUSH_TEMPLATES_LIST_LOAD]({ commit, state }, { organization_id, params = {} }) {
    return api.list(
      'organization',
      `${organization_id}/push_templates`,
      params,
      state,
      commit,
      PUSH_TEMPLATES_LIST_LOADING_CHANGE,
      PUSH_TEMPLATES_LIST_CHANGE
    );
  },

  /**
   * Загружает список (для выбора в форме)
   */
  [PUSH_TEMPLATES_LIST_LOAD_SELECT]({ commit, state }, { organization_id, params = {} }) {
    return api.list(
      "organization",
      `${organization_id}/push_templates/list`,
      params,
      state,
      commit,
      PUSH_TEMPLATES_LIST_LOAD_SELECT_LOADING_CHANGE,
      PUSH_TEMPLATES_LIST_LOAD_SELECT_CHANGE
    );
  },

  /**
   * Загружает список доступных компаний(организаций) по которым есть хотя бы один шаблон Push
   */
  [PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES]({ commit, state }, { params = {} }) {
    return api.list(
      'organization.push_templates.companies',
      null,
      params,
      state,
      commit,
      PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_LOADING_CHANGE,
      PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_CHANGE
    );
  },

  /**
   * Загружает список доступных языков для шаблонов Push
   */
  [PUSH_TEMPLATES_LANGUAGES]({ commit, state }, params = {}) {
    return api.list(
      'organization.push_templates.languages',
      null,
      params,
      state,
      commit,
      PUSH_TEMPLATES_LANGUAGES_LOADING_CHANGE,
      PUSH_TEMPLATES_LANGUAGES_CHANGE
    );
  },

  /**
   * Загружает один шаблон Push
   */
  [PUSH_TEMPLATE_LOAD]({ commit, state }, { organization_id, push_template_id }) {
    return api.load(
      'organization',
      `${organization_id}/push_templates/${push_template_id}`,
      state,
      commit,
      PUSH_TEMPLATE_LOADING_CHANGE,
      PUSH_TEMPLATE_CHANGE,
      PUSH_TEMPLATE_ERRORS_CHANGE
    );
  },

  /**
   * Очищает текущий шаблон Push (для формы создания)
   */
  [PUSH_TEMPLATE_SET_EMPTY]({ commit }) {
    commit(PUSH_TEMPLATE_CHANGE, null);
  },

  /**
   * Создает новый шаблон Push
   */
  [PUSH_TEMPLATE_CREATE]({ commit, state }, { organization_id, data }) {
    return api.create(
      'organization',
      `${organization_id}/push_templates`,
      data,
      state,
      commit,
      PUSH_TEMPLATE_LOADING_CHANGE,
      PUSH_TEMPLATE_CHANGE,
      PUSH_TEMPLATE_ERRORS_CHANGE
    );
  },

  /**
   * Обновляет шаблон Push
   */
  [PUSH_TEMPLATE_UPDATE]({ commit, state }, { organization_id, push_template_id, data }) {
    return api.update(
      'organization',
      `${organization_id}/push_templates/${push_template_id}`,
      data,
      state,
      commit,
      PUSH_TEMPLATE_SAVING_CHANGE,
      PUSH_TEMPLATE_CHANGE,
      PUSH_TEMPLATE_ERRORS_CHANGE
    );
  },

  /**
   * Удаляет шаблон Push
   */
  [PUSH_TEMPLATE_DELETE]({ commit, state }, { organization_id, push_template_id }) {
    commit(PUSH_TEMPLATE_DELETING_CHANGE, true);
    return api.delete(
      'organization',
      `${organization_id}/push_templates/${push_template_id}`,
      state,
      commit,
      PUSH_TEMPLATE_CHANGE
    ).finally(() => {
      commit(PUSH_TEMPLATE_DELETING_CHANGE, false);
    });
  },

  /**
   * Preview Push-шаблона с реальными данными заказа
   * @param {Object} context - Vuex context
   * @param {Object} data - Данные для preview
   * @param {string} data.template_content - Текст содержимого шаблона
   * @param {string} data.title - Заголовок шаблона
   * @param {string} data.image - URL изображения
   * @param {string} data.icon - URL иконки
   * @param {string} data.link - URL ссылки
   * @param {string} data.order_key - Ключ заказа
   * @param {string} data.render_engine - Движок рендеринга ('legacy' или 'jinja2')
   * @returns {Promise} Promise с результатом или ошибкой
   */
  [PUSH_TEMPLATE_PREVIEW]({ commit }, data) {
    const url = api.format('organization.push_templates.preview');
    // Используем опцию throwOnError для получения оригинальных ошибок от бэкенда
    return http.post(url, data, { throwOnError: true });
  },
};

const mutations = {
  [PUSH_TEMPLATES_LIST_LOADING_CHANGE](state, data) {
    state.push_templates_list_loading = data;
  },

  [PUSH_TEMPLATES_LIST_CHANGE](state, data) {
    if (data?.data) {
      state.push_templates_list = data.data;
      state.push_templates_list_total = data.total;
      state.push_templates_list_per_page = data.per_page;
      state.push_templates_list_page = data.page;
    } else {
      state.push_templates_list = [];
      state.push_templates_list_total = 0;
      state.push_templates_list_per_page = 20;
      state.push_templates_list_page = 1;
    }
  },

  [PUSH_TEMPLATES_LIST_LOAD_SELECT_LOADING_CHANGE](state, data) {
    state.push_templates_list_select_loading = data;
  },

  [PUSH_TEMPLATES_LIST_LOAD_SELECT_CHANGE](state, data) {
    if (data?.data) {
      state.push_templates_list_select = data.data;
      state.push_templates_list_select_total = data.total;
      state.push_templates_list_select_per_page = data.per_page;
      state.push_templates_list_select_page = data.page;
    } else {
      state.push_templates_list_select = [];
      state.push_templates_list_select_total = 0;
      state.push_templates_list_select_per_page = 20;
      state.push_templates_list_select_page = 1;
    }
  },

  [PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_LOADING_CHANGE](state, data) {
    state.push_templates_list_select_companies_loading = data;
  },

  [PUSH_TEMPLATES_LIST_LOAD_SELECT_COMPANIES_CHANGE](state, data) {
    if (data?.data) {
      state.push_templates_list_select_companies = data.data;
      state.push_templates_list_select_companies_total = data.total;
      state.push_templates_list_select_companies_per_page = data.per_page;
      state.push_templates_list_select_companies_page = data.page;
    } else {
      state.push_templates_list_select_companies = [];
      state.push_templates_list_select_companies_total = 0;
      state.push_templates_list_select_companies_per_page = 20;
      state.push_templates_list_select_companies_page = 1;
    }
  },

  [PUSH_TEMPLATE_CHANGE](state, data) {
    const empty = push_template_empty();
    state.push_template = data?.data ? { ...empty, ...data.data } : empty;
  },

  [PUSH_TEMPLATE_LOADING_CHANGE](state, data) {
    state.push_template_loading = data;
  },

  [PUSH_TEMPLATE_SAVING_CHANGE](state, data) {
    state.push_template_saving = data;
  },

  [PUSH_TEMPLATE_ERRORS_CHANGE](state, data) {
    state.push_template_errors = data;
  },

  [PUSH_TEMPLATE_DELETING_CHANGE](state, data) {
    state.push_template_deleting = data;
  },

  [PUSH_TEMPLATES_LANGUAGES_LOADING_CHANGE](state, data) {
    state.push_templates_languages_loading = data;
  },

  [PUSH_TEMPLATES_LANGUAGES_CHANGE](state, data) {
    if (data?.data) {
      state.push_templates_languages = data.data;
    } else {
      state.push_templates_languages = [];
    }
  },
};

export default {
  state,
  actions,
  mutations,
};
